import { render, staticRenderFns } from "./LoginCardLogout.vue?vue&type=template&id=6d6ca8aa&scoped=true"
import script from "./LoginCardLogout.vue?vue&type=script&lang=ts"
export * from "./LoginCardLogout.vue?vue&type=script&lang=ts"
import style0 from "./LoginCardLogout.vue?vue&type=style&index=0&id=6d6ca8aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ca8aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
